<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">

  <div class="form-group form-row mx-1">
    <label mat-raised-button [matTooltip]="infoBulle" matTooltipClass="tooltip-large" [matTooltipPosition]="positionIB"
      [for]="'input-select-' + idHtml"
      [class]="'form-label my-auto ' + classeColLabel + ' ' + classeSupplementaire">{{libelle$ | async }}
      <i *ngIf="infoBulle !== ''" class="material-icons md-dark md-18" aria-hidden="true">
        info
      </i>
    </label>
    <div [class]="'input-group ' + classeColInput">
      <div class="input-group">
        <input (blur)="onBlurInput($event)" [readOnly]="afficherEnLectureSeule" type="text" class="form-control"
          [id]="'input-select-'+ idHtml" [formControlName]="label + '_filtre_valeur'" (focus)="onFocusInput($event)"
          (keyup)="scroll(target); onKeyupInput($event)" autocomplete="off" [class.is-warning]="aErreurCroiseeActive()"
          [class.is-invalid]="champInvalide()" [class.is-valid]="champValide()" bisKeypadNavigation>
        <div (click)="cliqueSupprimer()" class="input-group-append"
          *ngIf="filtreEnCoursSaisie && ! afficherEnLectureSeule">
          <i class="input-group-text input-group-sm material-icons" aria-hidden="true">
            close
          </i>
        </div>
        <div (click)="cacheOptions = false; focusInput()" class="input-group-append last-"
          *ngIf="cacheOptions === true && ! afficherEnLectureSeule && utileAfficherListe">
          <i class="input-group-text material-icons" aria-hidden="true">
            expand_more
          </i>
        </div>
        <div (click)="cacheOptions = true" class="input-group-append"
          *ngIf="cacheOptions === false && utileAfficherListe">
          <i class="input-group-text material-icons" aria-hidden="true">
            expand_less
          </i>
        </div>
      </div>
      <div class="liste-select col-12 px-0">
        <ul [hidden]="cacheOptions" class="list-group">
          <div *ngFor="let item of modalitesFiltrees; index as i">
            <li *ngIf="i < nbChoixVisiblePossible" class="list-group-item py-1" style="cursor: pointer"
              [class.list-group-item-secondary]="i===choixIndexMenu" (click)="choixModalite(); focusInput()"
              (mouseenter)="choixMenu(i)">
              <span *ngIf="montreCode">{{ item.code }} – </span>{{ item.libelle }}
            </li>
          </div>
          <li *ngIf="modalitesFiltrees.length > nbChoixVisiblePossible"
            class="list-group-item py-0 small text-muted text-right">Trop
            de résultats, merci d’affiner votre recherche</li>
        </ul>
      </div>
    </div>
    <bis-affiche-erreurs class="col-12" *ngIf="erreursAffichable()" [erreurs]="rootForm.get(label).errors">
    </bis-affiche-erreurs>
    <div #target></div>
  </div>
</form>